var _style, _rect, _g, _path, _path2, _path3, _defs, _g2, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMicrosoftPowerpoint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;}\n\t.st1{opacity:0.2;}\n\t.st2{fill:#FFFFFF;}\n\t.st3{opacity:0.12;}\n\t.st4{fill:#D35230;}\n\t.st5{fill:#ED6C47;}\n\t.st6{fill:#FF8F6B;}\n\t.st7{clip-path:url(#SVGID_2_);}\n\t.st8{opacity:0.48;}\n\t.st9{opacity:0.24;}\n\t.st10{fill:#C43E1C;}\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    className: "st0",
    width: 512,
    height: 512
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PowerPoint"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_142"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Directional"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M275.4,48.4h0.2c114.7,0,207.5,92.9,207.5,207.5v0.2c0,114.7-92.9,207.5-207.5,207.5h-0.2 c-114.7,0-207.5-92.9-207.5-207.5v-0.2C67.7,141.3,160.8,48.4,275.4,48.4z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M275.4,48.4h0.2c114.7,0,207.5,92.9,207.5,207.5v0.2c0,114.7-92.9,207.5-207.5,207.5h-0.2 c-114.7,0-207.5-92.9-207.5-207.5v-0.2C67.7,141.3,160.8,48.4,275.4,48.4z"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Circle",
    className: "st4",
    d: "M275.4,48.4h0.2c114.7,0,207.5,92.9,207.5,207.5v0.2c0,114.7-92.9,207.5-207.5,207.5h-0.2 c-114.7,0-207.5-92.9-207.5-207.5v-0.2C67.7,141.3,160.8,48.4,275.4,48.4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M275.4,48.6C161,48.6,68.1,141.4,68.1,255.9h207.4V48.6H275.4z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M275.4,48.6c114.5,0,207.4,92.9,207.4,207.4H275.4V48.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M473.8,194.4c-4.1-13-9.4-25.4-15.7-37.3c-6.7-11.7-14.4-22.9-23-33.1 c-39.6-48.2-98.8-76-161.3-75.6l0,0c-114.5,0-207.4,92.9-207.4,207.4l0,0l0,0c1.1,114.5,94.7,206.5,209.3,205.4 s206.5-94.7,205.4-209.3c-0.2-19.4-3.1-38.9-8.8-57.6L473.8,194.4z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "st7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ambient"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M48.5,139.1h194.4c10.8,0,19.6,8.8,19.6,19.6v194.4c0,10.8-8.8,19.6-19.6,19.6H48.5 c-10.8,0-19.6-8.8-19.6-19.6V158.7C28.8,147.9,37.7,139.1,48.5,139.1z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M48.5,139.1h194.4c10.8,0,19.6,8.8,19.6,19.6v194.4c0,10.8-8.8,19.6-19.6,19.6H48.5 c-10.8,0-19.6-8.8-19.6-19.6V158.7C28.8,147.9,37.7,139.1,48.5,139.1z"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Light_Circle",
    className: "st0",
    d: "M473.8,194.4c-4.1-13-9.4-25.4-15.7-37.3c-6.7-11.7-14.4-22.9-23-33.1 c-39.6-48.2-98.8-76-161.3-75.6l0,0c-114.5,0-207.4,92.9-207.4,207.4l0,0l0,0c1.1,114.5,94.7,206.5,209.3,205.4 s206.5-94.7,205.4-209.3c-0.2-19.4-3.1-38.9-8.8-57.6L473.8,194.4z"
  }))))))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M48.5,139.1h194.4c10.8,0,19.6,8.8,19.6,19.6v194.4c0,10.8-8.8,19.6-19.6,19.6H48.5 c-10.8,0-19.6-8.8-19.6-19.6V158.7C28.8,147.9,37.7,139.1,48.5,139.1z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M147.3,192.6c12.4-0.7,24.7,2.9,34.6,10.1c8.3,7.7,12.6,18.9,11.5,30.2c0.5,15.8-8.5,30.4-23,36.9 c-7.9,3.8-16.6,5.6-25.4,5.2h-23v45H97.2V193.3L147.3,192.6z M121.9,255.9h21.2c6.7,0.4,13.3-1.6,18.7-5.8 c4.5-4.3,6.8-10.3,6.5-16.4c0-13.9-8.3-20.9-24.5-20.9h-22L121.9,255.9L121.9,255.9z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrosoftPowerpoint);
export default __webpack_public_path__ + "static/media/microsoft-powerpoint.a7df5ae1a6664f2d4de57c96a0d590ef.svg";
export { ForwardRef as ReactComponent };